import { useState, useEffect } from "react";

import { loadStoreLedgerTranscationList } from "../services/storeLedgerService";

const useStoreLedgerTransactionList = (selectedIDMaterial = null) => {
    const [ledgerTransList, setLedgerTransList] = useState([]);
    const [isIssuedIndentDataLoaded, setIsIssuedIndentDataLoaded] = useState(false);

    const fetchLedgerList = async (selectedIDMaterial) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_material: selectedIDMaterial, // if your API expects this
        };

        try {
            const data = await loadStoreLedgerTranscationList(para);
            if (data && data.length > 0) {
                setLedgerTransList(data);
                setIsIssuedIndentDataLoaded(true);
            }
        } catch (error) {
            // handle error
        }
    };

    useEffect(() => {
      
            fetchLedgerList(selectedIDMaterial);
       
    }, [isIssuedIndentDataLoaded, selectedIDMaterial]); // also re-fetch when selectedID changes

    const loadLedgerListByMaterial = async (selectedIDMaterial) => {
        await fetchLedgerList(selectedIDMaterial);
    };

    return {
        ledgerTransList,
        setLedgerTransList,
        loadLedgerListByMaterial,
    };
};
export default useStoreLedgerTransactionList;